<template>
  <div>
    <div class="badgesWrap">
      <!-- <div class="badgesBtn badgesBtnActive">
                全部
            </div>
            <div class="badgesBtn">
                单课程
            </div>
            <div class="badgesBtn">
                专栏
            </div>
            <div class="badgesBtn">
                大专栏
            </div> -->
    </div>
    <div class="marginTop10">
      <div v-if="datalist.length > 0">
        <div class="display_flex marginTop20"
             v-for="(item, index) in datalist"
             :key="index">
          <div class="pub_square"
               v-for="(itemn, indexn) in item"
               :style="indexn%3==0?'margin-left:0':'margin-left:20px;'"
               :key="indexn">
            <div class="pubs_img"
                 @click="courseclick(itemn)">
              <img :src="itemn.acr_Pict"
                   width="280"
                   height="158" />
            </div>
            <div class="pubs_body">
              <div class="pubs_title"
                   @click="courseclick(itemn)">
                {{ ellipsis(itemn.title, 15) }}
              </div>
              <div class="pubs_label display_between">
                <div>
                  <span style="cursor: pointer;"
                        v-for="(itemX, indexX) in (itemn.labelName || '').split(',').slice(0, (itemn.labelName || '').split(',').length - 1)"
                        :key="indexX"
                        @click="onsearch(itemX)">
                    {{ itemX }}
                  </span>
                </div>
                <div class="pubs_cancel">
                  <!-- 取消收藏 -->
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip"
                     style="color:#F01414FF">
                  <span v-if="item.discount > 0">VIP专享</span>
                  <span v-else>免费</span>
                </div>
                <div class="pubs_rentou">
                  <img src="/image/geren/ren.png" />
                  {{ itemn.playSum }}人
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="ishow">暂无数据</div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
export default {
  name: 'ShCourseList',
  props: {
    datalist: {
      type: Array,
    },
    ishow: {
      type: Boolean,
      // default: false,
    },
  },
  data () {
    return {
      apiData: [],
    };
  },
  methods: {
    onsearch (keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords,
          tagIndexmuber: 'ShCourseList',
        },
      });
      window.open(href, '_blank');
    },
    /** 课程跳转*/
    courseclick (item) {
      let id = item.id;
      let url = this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id;
      window.open(url);
    },
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          var usedata = data.ShCourseList.data;
          that.apiData = lodash.chunk(usedata, 3);
        })
    },
    submit () {
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped>
.badgesBtn {
    height: 30px;
    border-radius: 30px;
    padding: 0 20px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    border: 1px solid #ddd;
    cursor: pointer;
}
.badgesBtnActive {
    background: #0b8686;
    color: #fff;
}
.pub_square {
    width: 280px;
}
.pubs_img {
    width: 280px;
}
</style>
